/**
 * Load Calendars
 */
(function($) {
    var s,
    loadCalendars = {

      settings: {
        loadMoreLink: $('#js-calendar-next-month'),
        counter: 1,
        months: $(".calendar-container").find(".calendar-month")
      },

      init: function(){
        s = this.settings;
        this.bindEvents();
      },

      bindEvents: function() {
        s.loadMoreLink.click(function(e) {
          e.preventDefault();
          loadCalendars.loadNextMonth();
        });
      },

      loadNextMonth: function() {
        s.months.eq(s.counter).slideDown();
        s.counter++;
        if (s.counter >= s.months.length) {
          $(this).fadeOut();
        }
      },
    };
  loadCalendars.init();
})(jQuery);
